<template>
  <v-layout wrap class="app-sidebar" :class="{ 'open': active }">
	  <v-flex xs12>
			<button v-if="$route.name === 'page-home'" @click="changeActive" class="btn-menu btn-auto pa-0">
				<img :src="active ? 
				'https://web-apprunn.s3-sa-east-1.amazonaws.com/close.svg' :
				'https://web-apprunn.s3-sa-east-1.amazonaws.com/open-menu.svg'" alt="cerrar menu" width="24" />
			</button>
			<button v-else @click="changeActive" class="btn-menu btn-auto pa-0">
				<img
					:src="active ?
					'https://web-apprunn.s3-sa-east-1.amazonaws.com/close.svg' : 
					'https://web-apprunn.s3-sa-east-1.amazonaws.com/menu-blue.svg'"
					width="24"
				/>
			</button>
			<router-link :class="{ 'open': active }" to="/" v-if="$route.name === 'page-pillars'" class="return-home">
				Volver
			</router-link>
			<p class="border-sidebar"></p>
		<v-flex v-if="active" d-flex xs12 md-4 column class="menu-container">
		  <v-flex align-center d-flex v-for="(item, index) in items" :key="index" class="item-links">
			  <v-flex xs1 pt-3>
				  <p class="circle-css"></p>
			  </v-flex>
			  <v-flex xs10>
				<a v-if="item.href" :href="item.href" class="name-links">
					<button @click="closeModal(item)">
						{{ item.name }}
					</button>
				</a>
				<router-link v-else :to="item.link" class="name-links">
					<button @click="closeModal">
						{{ item.name }}
					</button>
				</router-link>
			  </v-flex>
		  </v-flex>
	  </v-flex>
	  <p class="border-sidebar"></p>
	</v-flex>
  </v-layout>
</template>

<script>
function closeModal(item) {
	this.$emit('close-modal', item);
}

function changeActive() {
	this.$emit('change-active');
}

export default {
	name: 'app-sidebar',
	methods: {
		closeModal,
		changeActive,
	},
	props: {
		items: {
			type: Array,
			default: () => [],
		},
		active: {
			type: Boolean,
			default: false,
		},
	},
};
</script>

<style lang="scss" scoped>
.app-sidebar {
	padding: 60px 0 0 58px;
	position: absolute;
	z-index: 44;

	@media (max-width: 1024px) {
		padding: 34px 26px;
	}

	&.open {
		background-color: map-get($colors, white);
		box-shadow: 0 2px 37px 0 rgba(0, 0, 0, 0.5);
		height: 100vh;
		padding: 46px 0 0 44px;
		position: fixed;
		width: 321px;

		@media (max-width: 960px) {
			padding: 30px 0 0 28px;
			width: calc(100vw - 60px);
		}

		.return-home {
			display: block;
		}

		.border-sidebar {
			background-color: map-get($colors, blue-regular);
			height: 32%;
			margin: 11px 0 0 4px;
			width: 1px;

			@media (max-width: 960px) {
				height: 160px;
			}

			@media (max-width: 415px) and (min-width: 375px) {
				height: 29%;
			}

			@media (max-width: 325px) {
				height: 135px;
			}

			@media (min-width: 765px) and (max-width: 850px) {
				height: 35%;
			}
		}

		.btn-menu {
			position: relative;
			right: 6px;
		}
	}
}

.name-links {
	color: map-get($colors, blue-regular);
	font-family: 'Lato', sans-serif;
	font-weight: 400;
	font-size: map-get($sizes, large);
	text-decoration: none;
}

.circle-css {
	background-color: map-get($colors, blue-regular);
	border-radius: 50%;
	height: 9px;
	width: 9px;

}

.menu-container {
	background-color: map-get($colors, white);
	display: flex;
	flex-direction: column;
}

.item-links:hover {
	.circle-css {
		background-color: map-get($colors, base);
	}

	.name-links {
		color: map-get($colors, base);
		font-family: 'Lato', sans-serif;
		font-weight: bold;
		font-size: map-get($sizes, xlarge);
	}
}

.return-home {
	color: #05316a;
	display: none;
	font-family: 'Lato', sans-serif;
	font-weight: bold;
	font-size: 25px;
	position: absolute;
	text-decoration: none;
	right: 25px;
	top: 42px;
}
</style>


// WEBPACK FOOTER //
// src/components/home/app-sidebar.vue